/**
 * Card for updating billing information that appears on the profile management page
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import Done from '@material-ui/icons/Done';

import BillingFormWrapper from 'components/BillingFormWrapper/BillingFormWrapper';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    submit: PropTypes.string.isRequired,
    blurb: PropTypes.string.isRequired,
  }).isRequired,
  completeBillingSetup: PropTypes.func.isRequired,
  getOrg: PropTypes.func.isRequired,
  needsBilling: PropTypes.bool.isRequired,
  isFastlaneCustomer: PropTypes.bool.isRequired,
};

const defaultProps = {
  className: null,
};

export function UnstyledBillingCard({
  className,
  classes,
  completeBillingSetup,
  getOrg,
  needsBilling,
  isFastlaneCustomer,
}) {
  // eslint-disable-next-line consistent-return
  function billingCompleteHandler() {
    if (needsBilling) {
      completeBillingSetup();
      getOrg();
    } else {
      return false;
    }
  }

  let blurb =
    'Your current Credit Card has been stored. To update, please enter your new information below.';

  if (isFastlaneCustomer) {
    blurb =
      'Your account is currently consolidated with your Rackspace account. You can convert to credit card billing by entering a card below.';
  } else if (needsBilling) {
    blurb =
      "Please confirm your method of payment to get unlimited access to all of ObjectRocket's platform.";
  }

  return (
    <Card className={className}>
      <CardHeader title="Payment Method" />
      <CardContent>
        <Typography className={classes.blurb}>{blurb}</Typography>
        <BillingFormWrapper
          onSuccess={billingCompleteHandler}
          screen="profile"
          className={classes.billingForm}
          allowMultipleSubmissions
          buttonText={<Done />}
          buttonProps={{
            name: 'submit',
            variant: 'fab',
            color: 'primary',
            size: 'small',
            className: classes.submit,
          }}
        />
      </CardContent>
    </Card>
  );
}

UnstyledBillingCard.propTypes = propTypes;
UnstyledBillingCard.defaultProps = defaultProps;

const styles = (theme) => ({
  submit: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),

    [theme.breakpoints.only('sm')]: {
      marginTop: 0,
      marginLeft: theme.spacing(1),
    },
  },
  blurb: {
    fontStyle: 'italic',
  },
  betaBlurb: {
    fontStyle: 'italic',
    marginTop: theme.spacing(2),
  },
  billingForm: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
    [theme.breakpoints.only('sm')]: {
      display: 'flex',
    },
  },
});

export default withStyles(styles)(UnstyledBillingCard);
